// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"7253":"879ca50fadbe7673ee24","8278":"13d5a019874d7c825800"}[chunkId] + ".css";
};